import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const SpotlightImage = ({ src, alt, caption, testid, fit = "cover" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <div ref={ref} data-testid={testid} className="relative overflow-hidden border-y border-white/10 h-[50vh] md:h-[70vh]">
      <motion.img
        src={src}
        alt={alt}
        style={fit === "cover" ? { y } : {}}
        className={`absolute inset-0 w-full ${fit === "cover" ? "h-[125%] object-cover" : "h-full object-contain"}`}
      />
      <div className={`absolute inset-0 ${fit === "cover" ? "bg-black/30" : ""}`} />
      {caption && (
        <p data-testid={`${testid}-caption`} className="absolute bottom-5 left-6 md:left-12 text-xs uppercase tracking-[0.3em] text-white/60">
          {caption}
        </p>
      )}
    </div>
  );
};
